import { useGetContactsCountQuery } from "services/contacts/contacts.api";
import { FindAllContactsDto } from "types/dto/contacts";

export function useContactsCount(params: Omit<FindAllContactsDto, 'pageIndex' | 'pageSize'>) {
    const {
        name,
        address,
        phoneNumber,
        ticketId,
        customerCode,
        wardId,
        districtId,
    } = params;

    const shouldFetch = !!(
        name ||
        address ||
        phoneNumber ||
        ticketId ||
        customerCode ||
        wardId ||
        districtId
    );

    const queryParams = shouldFetch
        ? {
            name,
            address,
            phoneNumber,
            ticketId,
            customerCode,
            wardId,
            districtId
        }
        : {
            name: '',
            address: '',
            phoneNumber: '',
            ticketId: undefined,
            customerCode: '',
            wardId: undefined,
            districtId: undefined
        };
    const { data: count } = useGetContactsCountQuery(queryParams, {
        skip: !shouldFetch,
    });

    return {
        count: shouldFetch ? count?.data || 0 : 0
    }
}